import ApiUrl from "../../configTools/apiUrl";

const UserListings = (username,setValues)=>{
    console.log(ApiUrl.API_URL_ListingUser+'/'+username)
    fetch(ApiUrl.API_URL_ListingUser+'/'+username)
    .then(res=>res.json())
    .then(data =>{
        if(data.success){
            setValues(data.responce);
        }
    });
}
export default {UserListings}